import * as React from "react";
export const renderPlaceholderInfo = (componentPrefix) => {
    return (React.createElement("div", { className: `rj-ev-list__${componentPrefix}__player-info` },
        React.createElement("div", { className: `rj-ev-list__${componentPrefix}__player-names-wrap` },
            React.createElement("div", { className: `rj-ev-list__${componentPrefix}__player-name` }),
            React.createElement("div", { className: `rj-ev-list__${componentPrefix}__player-name` })),
        React.createElement("div", { className: `rj-ev-list__${componentPrefix}__icon` })));
};
//# sourceMappingURL=renderPlaceholderInfo.js.map